<template>
  <div class="message">
    <h4>全部消息</h4>
    <div class="msgWrap" v-if="messageData.length > 0">
      <div class="msgItem" v-for="(item, index) in messageData" :key="index">
        <div class="msgImg">
          <img src="/img/messageTips.png" alt="" style="width: 50px; height: 50px" />
        </div>
        <div class="content">
          <div class="content_top">
            <h4>消息提醒</h4>
            <span>{{ item.createdTime | formatDate }}</span>
          </div>
          <div class="content_bottom">
            <p :class="{ pSty: !(showMore.status && index === showMore.num) }">
              <span>{{ item.content }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data" v-else>
      <img src="/img/no_data.043dd92a.png" alt="暂无消息记录" />
    </div>
  </div>
</template>

<script>
import { getToken, getUser } from '@/utils/auth'

export default {
  name: 'MyMessage',
  data() {
    return {
      showMore: { num: 1000, status: false },
      messageData: []
    }
  },
  filters: {
    formatDate(val) {
      if (!val) return ''
      const date = new Date(val)
      const y = date.getFullYear()
      const M = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const m = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')
      return `${y}-${M}-${d} ${h}:${m}:${s}`
    }
  },
  mounted() {
    this.messageFn()
  },
  methods: {
    moreFn(index) {
      this.showMore.status = !this.showMore.status
      this.showMore.num = index
    },
    messageFn() {
      const user = getUser()
      const customerId = user ? (typeof user === 'string' ? JSON.parse(user).id : user.id) : ''
      this.$axios({
        method: 'get',
        url: '/realNet/message/getMessages',
        headers: { token: getToken() },
        params: { customerId }
      }).then(res => {
        this.messageData = res.data.result.content || []
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
  width: 930px;

  > h4 {
    padding-bottom: 16px;
    font-size: 16px;
    color: #000;
    border-bottom: 1px solid #ddd;
  }

  .msgItem {
    width: 930px;
    margin: 15px 0;
    display: flex;

    .msgImg {
      width: 50px;
      height: 50px;
      margin-right: 10px;
      background-color: #ccc;
      border-radius: 50%;
      overflow: hidden;
    }

    .content {
      width: 80%;

      .content_top {
        width: 100%;
        height: 15px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        h4 {
          font-size: 14px;
          color: #000;
        }

        span {
          font-size: 12px;
          color: #999;
        }
      }

      .content_bottom {
        width: 100%;
        padding-bottom: 20px;
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;

        p {
          width: 80%;
          line-height: 1.45;

          span {
            font-size: 14px;
            color: #000;
          }
        }

        .pSty {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        > span {
          color: #3bc0d0;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }

  .no-data {
    text-align: center;
    padding: 80px 0;
  }
}
</style>
